import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { store as appStore, useAppDispatch, useAppSelector } from '@STORE/index';

import {
    PublishSectionBaseTextModalDispatchParams,
    publishSectionBaseTextModalSlice,
    PublishSectionBaseTextModalState,
} from '@REDUCERS';

function createPublishSectionBaseTextModalHook() {
    return function usePublishSectionBaseTextModal(equalityFn?: EqualityFn<PublishSectionBaseTextModalState>) {
        const state = useAppSelector((store) => store.publishSectionBaseTextModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: PublishSectionBaseTextModalDispatchParams, onSuccess?: (res: any) => void) => {
                dispatch(publishSectionBaseTextModalSlice.actions.open(params));
                const unsubscribe = appStore.subscribe(() => {
                    const currentState = appStore.getState().publishSectionBaseTextModal;
                    if (currentState.confirmed) {
                        if (onSuccess) {
                            onSuccess(currentState);
                        }
                        unsubscribe();
                    }
                });
            },
            close: () => dispatch(publishSectionBaseTextModalSlice.actions.close()),
            confirm: () => {
                dispatch(publishSectionBaseTextModalSlice.actions.confirm());
                dispatch(publishSectionBaseTextModalSlice.actions.close());
            },
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createPublishSectionBaseTextModalHook();
